import React, { useState } from "react";
// import FloatingLabelInput from 'react-floating-label-input';
import { Form } from "react-router-dom";
// import FloatingSelectInput from '../FloatingSelectInput';
// import Select from 'react-select';
import ReactSelect from "react-select";
import { generalsetting } from "../../config/imagesLink";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const {
  icon1: Settingicon1,
  icon2: Settingicon2,
  icon3: Settingicon3,
  icon4: Settingicon4,
} = generalsetting;

const GeneralSetting = () => {
  const options = [
    { value: "Mumbai", label: "Mumbai" },
    { value: "Thane", label: "Thane" },
    { value: "Pune", label: "Pune" },
  ];

  const [startDate, setStartDate] = useState(new Date());

  return (
    <>
      <div className="setting-header">
        <h4>General Setting</h4>
      </div>
      <Form>
        <div className="row p-4 settings">
          <div className="col-md-6">
            <div className="SettingInputfield">
              <label htmlFor="Username">
                Username <span style={{ color: "red" }}>*</span>
              </label>
              <input type="text" required/>
              <img src={Settingicon2} alt="" />
            </div>
          </div>
          <div className="col-md-6">
            <div className="SettingInputfield"></div>
          </div>
          <div className="col-md-6 mt-2">
            <div className="SettingInputfield">
              <label htmlFor="Username">
                First Name <span style={{ color: "red" }}>*</span>
              </label>
              <input type="text" />
            </div>
          </div>
          <div className="col-md-6 mt-2">
            <div className="SettingInputfield">
              <label htmlFor="Username">
                Last Name<span style={{ color: "red" }}>*</span>
              </label>
              <input type="text" />
            </div>
          </div>
          <div className="col-md-6 mt-2 selectdropdown">
            <div className="SettingInputfield">
              <label htmlFor="Username">
                Country <span style={{ color: "red" }}>*</span>
              </label>
              <ReactSelect
                className="custom-select SettingCountryName"
                styles={{
                  // control: (provided) => ({
                  //     ...provided,
                  //     width: 170,
                  // }),
                  menu: (provided) => ({
                    ...provided,
                    // width: 300,
                  }),
                }}
                options={options}
                placeholder=""
              />
            </div>
          </div>
          <div className="col-md-6 mt-2">
            <div className="SettingInputfield">
              <label htmlFor="Username">Location</label>
              <input type="text" />
            </div>
          </div>
          <div className="col-md-6 mt-2">
            <div className="SettingInputfield">
              <label htmlFor="Username">
                DOB <span style={{ color: "red" }}>*</span>
              </label>
              {/* <input type="date" onFocus={(e) => (e.target.type = "date")} /> */}
              <DatePicker selected={startDate} onChange={(date) => setStartDate(date)} />
              <img src={Settingicon4} alt="" />
            </div>
          </div>
          <div className="col-md-6 mt-2">
            <div className="SettingInputfield"></div>
          </div>
          <div className="col-md-6 mt-2">
            <div className="SettingInputfield">
              <label htmlFor="Username">
                Email Address <span style={{ color: "red" }}>*</span>
              </label>
              <input type="text" />
              <img src={Settingicon3} alt="" />
            </div>
          </div>
          <div className="col-md-6 mt-2">
            <div className="SettingInputfield">
              <label htmlFor="Username">Phone</label>
              <input type="text" />
              <img src={Settingicon1} alt="" />
            </div>
          </div>
          <div className="text-end">
            <button type="submit" className="mainBtn1 mt-3 text-center PrivacyBtn">
              Update
            </button>
          </div>
        </div>
      </Form>
    </>
  );
};

export default GeneralSetting;
